/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/self-closing-comp */
/* eslint-disable prefer-template */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-key */
/* eslint-disable no-alert */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { useState, useEffect, useMemo, useRef } from 'react';
import MaterialReactTable from 'material-react-table';
import EditIcon from '@mui/icons-material/Edit';
import { Delete as DeleteIcon } from '@mui/icons-material';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Box, Button, Card, Container, Grid, IconButton, Stack } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FavoriteIcon from '@mui/icons-material/Favorite';
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { ReactS3Client, uploadFile } from 'react-s3';
import { LoadingButton } from '@mui/lab';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { useDispatch, useSelector } from '../../../redux/store';
import { getelements } from '../../../redux/slices/element';
import { PATH_DASHBOARD } from '../../../routes/paths';
import Page from '../../../components/Page';
import Iconify from '../../../components/Iconify';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import axiosInstance from '../../../utils/axios';
import { FormProvider, RHFTextField, RHFDescription } from '../../../components/hook-form';
import Loader from '../Loader/Loader';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  padding: '40px 10px',
  borderRadius: '10px',
};

export default function Element() {
  const [age, setAge] = useState('');
  const { enqueueSnackbar } = useSnackbar();

  const columns = useMemo(
    () => [
      {
        accessorKey: 'id',
        header: 'ID',
        size: 1,
      },
      {
        accessorKey: 'title',
        header: 'Title',
        size: 1,
      },
      {
        accessorKey: 'schedule_date',
        header: 'Schedule Date',
        size: 1,
      },
      {
        accessorKey: 'video',
        header: 'video',
        size: 10,
        Cell: ({ row }) => {
          const comments = row?.original?.post_likes || [];
          console.log(comments, '<====row?.original?.post_likes');
          return (
            <>
              <Button
                fullWidth
                variant="contained"
                style={{ backgroundColor: 'deeppink' }}
                endIcon={<PlayCircleIcon icon={'eva:checkmark-circle-2-fill'} />}
              >
                <a href={row?.original?.video} style={{ color: 'white', textDecoration: 'none' }} target="_blank">
                  Watch Now
                </a>
              </Button>
            </>
          );
        },
      },
      {
        accessorKey: 'comments',
        header: 'Post Likes',
        size: 5,
        Cell: ({ row }) => {
          const comments = row?.original?.post_likes || [];
          console.log(comments, '<====row?.original?.post_likes');
          return (
            <>
              <div className="d-flex justify-content-around w-50">
                <p>{comments?.length}</p>
                <p>
                  <FavoriteIcon style={{ color: 'red' }} />
                </p>
              </div>
            </>
          );
        },
      },
      {
        accessorKey: 'comments',
        header: 'Comments',
        size: 5,
        Cell: ({ row }) => {
          const comments = row?.original?.comments || [];
          const comments1 = row?.original || [];
          console.log(row?.original, '<====row?.original?.comments');
          return (
            <>
              <div
                onClick={() => {
                  navigate(`/dashboard/comment/${comments1?.id}`);
                }}
                className="d-flex justify-content-around w-50"
                style={{ cursor: 'pointer' }}
              >
                <p>{comments?.length}</p>
                <p>
                  <MarkUnreadChatAltIcon style={{ color: 'red' }} />
                </p>
              </div>
            </>
          );
        },
      },
      // {
      //   accessorKey: 'comments',
      //   header: 'Comments Likes',
      //   size: 5,
      //   Cell: ({ row }) => {
      //     const comments = row?.original?.comments || [];
      //     return (
      //       <>
      //         {comments?.map((comment, index) => (
      //           <div className='d-flex justify-content-around w-50'>
      //             <p>{comment?.comment_likes?.length}</p>
      //             <p><FavoriteIcon style={{ color: 'red' }} /></p>
      //           </div>
      //         ))}
      //       </>
      //     );
      //   },
      // },
    ],
    []
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { elements } = useSelector((state) => state.element);
  const [loader, setLoader] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    dispatch(getelements());
  }, [dispatch]);

  useEffect(() => {
    if (elements.length) {
      setTableData(elements);
    }
    console.log(tableData, 'tabledata');
  }, [elements]);

  async function handleDelete(rowdata) {
    try {
      await axiosInstance.delete(`/video/${rowdata}`).then((response) => {
        if (response?.data?.status === true) {
          enqueueSnackbar('Video Deleted Successfully');
          dispatch(getelements());
        }
      });
    } catch (error) {
      enqueueSnackbar(error?.message, {
        variant: 'error',
      });
      console.error(error);
    }
  }

  async function handleStatus(id) {
    try {
      await axiosInstance.put(`/api/admin/companies/${id}/active_deactive`).then((response) => {
        if (response?.data?.status === true) {
          enqueueSnackbar('Company Status Changed Successfully');
          dispatch(getelements());
        }
      });
    } catch (error) {
      enqueueSnackbar(error?.message, {
        variant: 'error',
      });
      console.error(error);
    }
  }

  // File Upload Code Start
  const config = {
    bucketName: 'hnh-s3-bucket-for-testing',
    dirName: 'videos',
    /* optional */
    region: 'us-east-1',
    accessKeyId: 'AKIAY6BSA4RSES6TD3PP',
    secretAccessKey: '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',
  };

  const [progress, setProgress] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [files, setFiles] = useState('');

  const handleChange = (event) => {
    const file1 = event.target.files[0];
    const fileName = `${new Date().getTime()}-${file1.name}`; // Update file name based on data.title
    const reader = new FileReader();
    reader.onprogress = (event) => {
      if (event.lengthComputable) {
        const percent = (event.loaded / event.total) * 100;
        setProgress(percent);
        setFiles(file1);
      }
    };

    reader.onloadend = () => {
      setFeedback(`File has been uploaded successfully.`);
    };

    reader.readAsDataURL(file1);
  };

  const defaultValues = useMemo(
    () => ({
      title: '',
      desc: '',
      schedule_date: '',
    }),
    //  eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const methods = useForm({
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  console.log(files, 'file');

  const OnSubmit = async (data) => {
    setLoader(true);
    try {
      const options = {
        bucketName: config.bucketName,
        region: config.region,
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey,

        onProgress: (progress) => {
          setProgress((progress.loaded * 100) / progress.total);
        },
        keyPrefix: `${new Date().getTime()}-${files.name}`,
      };
      uploadFile(files, options)
        .then((datas) => {
          const formData = new FormData();
          formData.append('title', data?.title);
          formData.append('desc', data?.desc);
          formData.append('schedule_date', data?.schedule_date);
          formData.append('video', datas?.location);

          console.log(datas, 'data');
          setFeedback(`File has been uploaded successfully.`);
          axiosInstance
            .post('video', formData)
            .then((response) => {
              console.log(response?.data?.status, 'response');
              if (response?.data?.status == true) {
                enqueueSnackbar('Video Uploaded Successfully');
                setLoader(false);
                setOpen(false);
                dispatch(getelements());
              }
            })
            .catch((err) => {
              console.error(err);
              setLoader(false);
              setOpen(false);
            });
        })
        .catch((err) => {
          console.error(err);
          setFeedback(`Error uploading file.`);
          setLoader(false);
          setOpen(false);
        });
    } catch (error) {
      enqueueSnackbar(error?.message, {
        variant: 'error',
      });
      console.error(error);
      setLoader(false);
      setOpen(false);
    }
  };

  // File Upload Code End

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1); // Get tomorrow's date
  const tomorrowFormatted = tomorrow.toISOString().split('T')[0];

  return (
    <Page title="Video">
      <Container maxWidth="xl">
        <HeaderBreadcrumbs
          heading="Video"
          links={[{ name: '', href: '' }]}
          action={
            <Button onClick={handleOpen} variant="contained" startIcon={<CloudUploadIcon icon="eva:plus-fill" />}>
              upload video
            </Button>
          }
        />

        <MaterialReactTable
          columns={columns}
          data={tableData}
          enableRowActions
          renderRowActions={({ row }) => (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'nowrap',
                gap: '10px',
                justifyContent: 'flex-center',
              }}
            >
              {/* <IconButton
                color="primary"
                sx={{
                  border: "1px solid",
                  borderColor: "primary.main",
                }}
                onClick={() => { navigate(PATH_DASHBOARD.element.editelement(row.original.id)) }}
              >
                <EditIcon />
              </IconButton> */}
              <IconButton
                color="error"
                sx={{
                  border: '1px solid',
                  borderColor: 'error.main',
                }}
                onClick={() => {
                  handleDelete(row.original.id);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          )}
          positionActionsColumn="last"
        />

        <div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={open}>
              <Box sx={style}>
                <h4 className="px-5 mb-3 fw-bold">Add Post</h4>
                <FormProvider methods={methods} onSubmit={handleSubmit(OnSubmit)}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                      <Card sx={{ p: 3 }}>
                        <Stack spacing={3}>
                          <RHFTextField name="title" label="Title" />
                          <RHFTextField name="desc" label="Description" multiline rows={4} />
                          <RHFTextField
                            name="schedule_date"
                            type="date"
                            label="Schedule Date"
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ min: tomorrowFormatted }}
                          />

                          <div>
                            <label htmlFor="file-upload" style={buttonStyles.uploadButton} className="upload-button">
                              Upload videos
                            </label>
                            <input
                              id="file-upload"
                              type="file"
                              accept="video/*"
                              onChange={handleChange}
                              style={{ display: 'none' }}
                            />{' '}
                            <br />
                            <div className="progressContainer" style={buttonStyles.progressContainer}>
                              <progress id="progress" style={buttonStyles.progress} value={progress} max="100" />
                              <div style={buttonStyles.progressText} className="progressText">
                                {Math.round(progress)}%
                              </div>
                            </div>
                            <div style={{ color: 'red' }}>{feedback}</div>
                          </div>

                          <Grid item xs={12} md={12}>
                            <LoadingButton
                              fullWidth
                              type="submit"
                              variant="contained"
                              size="large"
                              loading={isSubmitting}
                            >
                              {loader ? <Loader /> : 'Submit'}
                            </LoadingButton>
                          </Grid>
                        </Stack>
                      </Card>
                    </Grid>
                  </Grid>
                </FormProvider>
              </Box>
            </Fade>
          </Modal>
        </div>
      </Container>
    </Page>
  );
}

const buttonStyles = {
  uploadButton: {
    display: 'inline-block',
    padding: '10px 20px',
    backgroundColor: '#F5003F',
    color: 'white',
    borderRadius: '5px',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'center',
    marginBottom: '20px',
  },
  uploadButtonHover: {
    backgroundColor: '#F5003F',
  },

  progressContainer: {
    position: 'relative',
    width: '100%',
  },

  progress: {
    width: '100%',
    height: '50px',
    color: 'red',
  },

  progressText: {
    position: 'absolute',
    top: '14px',
    left: '50%',
    transform: 'translateX(-50%)',
    color: '#F5003F',
  },
};
